// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

export const ADMIN_ALERTS_FETCH_BEGIN = 'syftacp/ADMIN_ALERTS_FETCH_BEGIN' as const
export const ADMIN_ALERTS_FETCH_FAILED = 'syftacp/ADMIN_ALERTS_FETCH_FAILED' as const
export const ADMIN_ALERTS_FETCH_SUCCEEDED = 'syftacp/ADMIN_ALERTS_FETCH_SUCCEEDED' as const
export const ADMIN_ALERTS_MARK_AS_NOTIFIED = 'syftacp/ADMIN_ALERTS_MARK_AS_NOTIFIED' as const
export const ADMIN_ALERTS_MARK_AS_READ = 'syftacp/ADMIN_ALERTS_MARK_AS_READ' as const
